import {Component, OnInit} from '@angular/core';
import {BlogServiceService} from './_services/blog-service.service';
import {ActivatedRoute} from '@angular/router';
import {BlogDetailsModel} from './_models/blogDetails.model';

@Component({
    selector: 'app-blog-details',
    templateUrl: './blog-details.component.html',
    styleUrls: ['./blog-details.component.scss']
})
export class BlogDetailsComponent implements OnInit {

    constructor(private blogService: BlogServiceService, private route: ActivatedRoute) {
    }

    blogDetails: BlogDetailsModel;
    isLoaded: boolean;
    currentUrl: string;

    // Total Category Elements
    marketingElem = 0;
    managementElem = 0;
    salesElem = 0;
    recrutElem = 0;

    ngOnInit() {
        this.currentUrl = window.location.href;
        this.route.params.subscribe(res => {
            const blogId = res.id;
            this.blogService.postDetails(blogId).subscribe((postData: any) => {
                this.blogDetails = postData;
                this.isLoaded = true;
            })
        })

        // this.marketingElements();
        // this.managementElements();
        // this.salesElements();
        // this.recrutElements();
    }


    // marketingElements() {
    //     this.blogService.listPublishedBlogPosts(6, 1, 'category', 'desc', {category: 'Marketing'}).subscribe((resp: any) => {
    //         this.marketingElem = resp.totalElements;
    //     })
    // }
    //
    // managementElements() {
    //     this.blogService.listPublishedBlogPosts(6, 1, 'category', 'desc', {category: 'Management'}).subscribe((resp: any) => {
    //         this.managementElem = resp.totalElements;
    //     })
    // }
    // salesElements() {
    //     this.blogService.listPublishedBlogPosts(6, 1, 'category', 'desc', {category: 'Sales'}).subscribe((resp: any) => {
    //         this.salesElem = resp.totalElements;
    //     })
    // }
    // recrutElements() {
    //     this.blogService.listPublishedBlogPosts(6, 1, 'category', 'desc', {category: 'Recruitment'}).subscribe((resp: any) => {
    //         this.recrutElem = resp.totalElements;
    //     })
    // }

}
